import React, { useEffect, useRef, useState } from "react";
import DataTable from "datatables.net-react";
import DT from "datatables.net-dt";
import NiceModal from "@ebay/nice-modal-react";
import { getEmail } from "../../services/clients";

DataTable.use(DT);

const ViewEmailsModal = NiceModal.create(({ public_id }) => {
  const [email, setEmail] = useState(null);
  //const emailTableRef = useRef(null);
  //const [emailTableData, setEmailTableData] = useState([]);
  //const modal = useModal();

  useEffect(() => {
    if (public_id) {
      getEmail(public_id).then((emails) => {
        console.log("!!! email: ", email);

        setEmail(emails);
        /*const emailData = emails.map((email) => {
          return [
            email.public_id,
            email.email,
            email.data,
            email.email_date ? new Date(email.email_date) : "",
          ];
        });*/
        //setEmailTableData(emailData);
      });
    }
    // eslint-disable-next-line
  }, [session_id]);

  /*const hide = (e) => {
    modal.remove();
  };*/

  return <div>Email</div>;

  /*
  return (
    <>
      <div className="w-5/12 h-auto force-height-90 force-center items-center flex overflow-x-hidden overflow-y-hidden overflow-hidden fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-full my-6 mx-auto max-w-3xl">
          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
            <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
              <h3 className="text-3xl font-semibold">
                {"Emails for " + username} ({email}){" "}
              </h3>
            </div>
            <div
              className="relative p-6 flex-auto overflow-y-auto"
              style={{ maxHeight: "70vh" }}
            >
              <div className="my-4 text-blueGray-500 text-lg leading-relaxed">
                Session ID: {session_id}
              </div>
              <div className="my-4 text-blueGray-500 text-lg leading-relaxed">
                Platform: {platform}
              </div>
              <div className="my-4 text-blueGray-500 text-lg leading-relaxed">
                Duration: {duration}
              </div>
              <DataTable
                ref={emailTableRef}
                data={emailTableData}
                className="display"
                options={{
                  responsive: true,
                  select: true,
                  pageLength: 25,
                  order: [[3, "desc"]],
                }}
              >
                <thead>
                  <tr>
                    <th>Public ID</th>
                    <th>Email</th>
                    <th>Data</th>
                    <th>Email Date</th>
                  </tr>
                </thead>
              </DataTable>
            </div>
            <div className="relative p-6 flex-auto"></div>
            <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
              <button
                className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="button"
                onClick={hide}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
    */
});

NiceModal.register("view-emails", ViewEmailsModal);

const EmailsTable = ({ emails = [], onUpdated = () => {} }) => {
  const tableRef = useRef(null);

  window.view = (public_id) => {
    console.log("!!! email: ", public_id);
    NiceModal.show("view-emails", {
      public_id,
    });
  };

  const tableData = emails.map((email) => {
    return [
      email.public_id,
      email.user_group,
      email.to_email,
      email.user,
      email.from_email,
      email.subject,
      new Date(email.sent_at),
      email.opened_at ? `Opened ${Date(email.opened_at)}` : "",
    ];
  });

  return (
    <div>
      <div style={{ fontSize: "32px", fontWeight: "bold" }}>
        Email Sessions ({emails.length})
      </div>
      <DataTable
        ref={tableRef}
        data={tableData}
        className="display"
        options={{
          responsive: true,
          select: true,
          pageLength: 25,
          order: [[6, "desc"]],
        }}
      >
        <thead>
          <tr>
            <th>ID</th>
            <th>Group</th>
            <th>Email</th>
            <th>User</th>
            <th>From</th>
            <th>Subject</th>
            <th>Sent At</th>
            <th>Opened At</th>
          </tr>
        </thead>
      </DataTable>
    </div>
  );
};

export default EmailsTable;
